const constants = {
  applyUrl: 'https://hub.eassist.me/employment/logon',
  toNewApplyPage: false,//设置为true则全部跳到新的页面注册
  maxMin: 50,//50分钟之前的用户跳转到旧的apply页面，50分钟后的用户跳转到新的apply页面
  abilityMin: 7, // Ability 测试倒计时的时间
}
export { constants }